import { createFetcher } from '../create-fetcher';
export const fetcher = createFetcher({});
//# sourceMappingURL=fetcher.js.map